import { Directive, Input } from '@angular/core';

import { OverdueCandidatesTrackingService } from './overdue-candidates-tracking.service';
import type { OverdueTrackingEvent } from '../analytics/overdue-candidate.analytics';

@Directive({
  selector: '[rtOverdueCandidatesTrack]',
  host: {
    '(click)': 'track()',
  },
  standalone: true,
})
export class OverdueCandidatesTrackingDirective {
  @Input() public trackingEvent: OverdueTrackingEvent;

  constructor(private service: OverdueCandidatesTrackingService) {}

  public track(): void {
    if (!this.trackingEvent) return;
    this.service.track(this.trackingEvent);
  }
}
